import type {MinisaleResponseBody} from '@dms/api/finance';

import type {BuyingFormType} from '../types/BuyingFormType';

/**
 * Extracted from useMinisaleUpdate so it can be unit-tested without loading the
 * hook, which pulls react, react-redux and the RTK Query endpoints from
 * @dms/api/customer. Its spec only calls this predicate. See T20-133319.
 */
export const shouldFetchMinisale = (
  values: BuyingFormType,
  miniSale: MinisaleResponseBody | null
) => {
  // If pricer changed, we should fetch
  if (values.pricedBy !== miniSale?.pricedBy) {
    return true;
  }

  // Check for changes in make and modelFamily
  const newMake = values.vehicleData?.make;
  const newModelFamily = values.vehicleData?.modelFamily;
  const oldMake = miniSale?.vehicleData?.make;
  const oldModelFamily = miniSale?.vehicleData?.modelFamily;

  // If both are defined in new values but not in old, fetch
  if (newMake && newModelFamily && (!oldMake || !oldModelFamily)) {
    return true;
  }

  // If both are defined in old values but not in new, fetch
  if (oldMake && oldModelFamily && (!newMake || !newModelFamily)) {
    return true;
  }

  return false;
};
